import { Redacted, Schema } from "effect";
import { privateDependencyFailure } from "@workerstation/shared/errors/private-cause";
export const EditorElementId = Schema.String;
export type EditorElementId = typeof EditorElementId.Type;
export class EditorElementFocusFailure extends privateDependencyFailure<EditorElementFocusFailure>()("EditorElementFocusFailure", "editor element focus") {}
export const editorElementFocusFailure = (cause: unknown) => new EditorElementFocusFailure({ cause: Redacted.make(cause) });
